require('./webpage_iframe_handler');
SharedPlayer = LP.module('SharedPlayer')
WebpagePreview =

  STYLE: "
      @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&display=swap');
      @keyframes fadeInUp {
        from {
          transform: translate3d(0,20px,0)
        }
        to {
          transform: translate3d(0,0,0);
          opacity: 1
        }
      }
      @-webkit-keyframes fadeInUp {
        from {
          transform: translate3d(0,20px,0)
        }
        to {
          transform: translate3d(0,0,0);
          opacity: 1
        }
      }
      body {
        position: relative;
        background: #fff;
        color: #45454a;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        font-family: \'Open Sans\', \'Roboto\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Inter\', \'Ubuntu\', Helvetica, Arial, sans-serif;
        height: 100%;
        padding: 0;
        margin: 0;
      }
      .webpage-placeholder {
        position: absolute;
        top: 20px;
        right: 20px;
        bottom: 0;
        left: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: 1px solid #ddd;
        border-bottom: 0;
        border-radius: 6px 6px 0 0;
      }
      .page-loading {
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 35px;
      }
      .helper-text {
        font-size: 18px;
        line-height: 1.6;
        margin-top: 20px;
        width: 100%;
        max-width: 350px;
        margin: 30px auto 30px auto;
      }
      .go-to-webpage {
        display: inline-block;
        color: #fff;
        background-color: #18598f;
        font-weight: 600;
        text-align: center;
        text-decoration: none;
        touch-action: manipulation;
        cursor: pointer;
        background-image: none;
        white-space: nowrap;
        padding: 0 12px;
        font-size: 15px;
        border-radius: 4px;
        -webkit-user-select: none;
        height: 41px;
        line-height: 41px;
        width: 180px;
        margin: 0 auto;
      }
      .go-to-webpage .lp-icon {
        margin-right: 6px;
      }
      .go-to-webpage:hover {
        background-color: #113e63;
      }
      .animated {
        animation-duration: 1.2s;
        animation-fill-mode: both;
        -webkit-animation-duration: 1.2s;
        -webkit-animation-fill-mode: both;
      }
      .animatedFadeInUp {
        opacity: 0;
      }
      .fadeInUp {
        opacity: 0;
        animation-name: fadeInUp;
        -webkit-animation-name: fadeInUp;
      }
    "

  FIREWALL_TOKEN_PARAM: LP.config.firewall_token_param

  decodeURIParams: (query) ->
    query = $.trim(String(query))
    if query[0] == '?'
      query = query.substring(1)
    params = query.split('&')
    result = {}
    count = 0
    while count < params.length
      param = params[count]
      pos = param.indexOf('=')
      if pos >= 0
        key = @decodeStr(param.substring(0, pos))
        val = @decodeStr(param.substring(pos + 1))
        result[key] = val
      count++
    result

  encodeStr: (value) ->
    value = @decodeStr(value)
    encodeURIComponent(String(value)).replace(/'/g,"%27").replace(/"/g,"%22")

  decodeStr: (value) ->
    decodeURIComponent(String(value).replace(/\+/g,  " "))

  validString: (value) ->
    $.trim(String(value)) != '' && $.trim(String(value)) != 'null' && typeof(value) != 'undefined'

  encodeURIParams: (params, {encode, encodeSymbols} = {encode: true, encodeSymbols: false}) ->
    pairs = []
    joined_param_str = '='
    if encodeSymbols
      joined_param_str = @encodeStr(joined_param_str)
    for key, value of params
      if @validString(value) && @validString(key)
        if encode
          pairs.push(@encodeStr(key) + joined_param_str + @encodeStr(value))
        else
          pairs.push(key + joined_param_str + value)
    if pairs.length == 0
      return ''
    joined_str = '&'
    if encodeSymbols
      joined_str = @encodeStr(joined_str)
    question_str = '?'
    if encodeSymbols
      question_str = @encodeStr(question_str)
    return question_str + pairs.join(joined_str)

  handleGoogleLink: (google_url, key, value, {encode, encodeSymbols, additional} = {encode: true, encodeSymbols: true, additional}) ->
    google_link = document.createElement("a")
    google_link.href = @decodeStr($.trim(String(google_url)))
    params = @decodeURIParams(google_link.search)
    params = $.extend(params,additional)
    if @validString(key) && @validString(value)
      params = $.extend(params, { "#{key}": value, 'preview_inside_iframe': '1' })
    google_search = @encodeURIParams(params, {encode: encode, encodeSymbols: encodeSymbols})
    google_port = $.trim(String(google_link.port))
    if @.validString(google_port) && google_port != '443' && google_port != '80'
      google_port = ':' + google_port
    else
      google_port = ''
    pathname = google_link.pathname
    unless pathname.substring(0, 1) == '/'
      pathname = '/' + pathname
    google_link.protocol + '//' + google_link.hostname + google_port + pathname + google_search

  _objectWithProperties: (obj, keys,  {only} = {only: false}) ->
    target = {}
    for i of obj
      if keys.indexOf(i) >= 0 && Object.prototype.hasOwnProperty.call(obj, i)
        if only
          target[i] = obj[i];
        else
          continue
      target[i] = obj[i] unless only
    return target

  appendToUrl: (url, key, value) ->
    url = $.trim(String(url))
    if url.substring(0, 2) == '//'
      url = window.location.protocol + url
    else if url.substring(0, 1) == '/'
      url = window.location.origin + url
    url = url.replace('http://', 'https://') if /^http:/.test(url)
    url = url.replace('https://', window.location.protocol + "//")
    link = document.createElement("a")
    link.href = $.trim(String(url))
    params = @decodeURIParams($.trim(String(link.search)))
    if /http(s)?:\/\/drive\.google\.com\/viewer\?/.test(link.href)
      obj = @_objectWithProperties(params, ['embedded', 'url', @FIREWALL_TOKEN_PARAM], {only: true})
      additionalGoogleParams = @_objectWithProperties(params, ['embedded', 'url', @FIREWALL_TOKEN_PARAM], {only: false})
      google_url = @handleGoogleLink(params['url'], key, value, {additional: additionalGoogleParams})
      search = @encodeURIParams($.extend(obj, { "url": google_url }))
    else
      if @validString(key) && @validString(value)
        params = $.extend(params, { "#{key}": value })
      search = @encodeURIParams(params)
    pathname = link.pathname
    unless pathname.substring(0, 1) == '/'
      pathname = '/' + pathname
    port = $.trim(String(link.port))
    if @.validString(port) && port != '443' && port != '80'
      port = ':' + port
    else
      port = ''
    link.protocol + '//' + link.hostname + port + pathname + search

  extractHostname: (url) ->
    # find & remove protocol (http, ftp, etc.) and get hostname
    if url.indexOf("//") > -1
      hostname = url.split('/')[2]
    else
      hostname = url.split('/')[0]
    # find & remove port number
    hostname = hostname.split(':')[0]
    # find & remove "?"
    hostname.split('?')[0]

  transformUrlIfNeeded: (url) ->
    url = $.trim(String(url))
    return @.appendToUrl(url) if /http(s)?:\/\/drive\.google\.com\/viewer\?/.test(url)
    if url.substring(0, 1) == '/'
      url = @appendToUrl(url, 'preview_inside_iframe', '1')
    else
      hostname = @extractHostname(url)
      if /lessonplanet/.test(hostname)
        url = @appendToUrl(url, 'preview_inside_iframe', '1')
    url

  load: (url, iframe, lti, $slideElement, data,  { detect_loading, onerror } = { detect_loading: true, onerror: null }) ->
    detect_loading ?= true
    page_url = @transformUrlIfNeeded(url)
    iframe.contentWindow.document.write("
      <div class='webpage-placeholder'>
        <div class='animated animatedFadeInUp fadeInUp'>
          <div class='page-loading'>Loading Resource</div>
          <i class='fa fa-refresh fa-spin fa-3x text-muted'></i>
          <div class='helper-text'>Some sources may take a while to load. You can open in a new tab at any time.</div>
          <a id='goto-lti-btn' class='go-to-webpage' href='#{page_url}'>
            <i class='lp-icon fa fa-external-link'></i>
            <span>Go to Webpage</span>
          </a>
        </div>
      </div>
    ");

    style = document.createElement('style');
    style.textContent = @STYLE

    fontAwesome = document.createElement('link')
    fontAwesome.setAttribute('rel','stylesheet')
    # We upgraded to FA 6 on LP but in this case we can still use the 4.7 CDN since we only need it for the spinner
    fontAwesome.setAttribute('href','//netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css')
    iframeContent = iframe.contentDocument

    iframeContent.head.appendChild(fontAwesome)
    iframeContent.head.appendChild(style)

    unless lti
      try
        if detect_loading
          SharedPlayer.WebPageIFrameHandler.tryEmbeddingWebPage($slideElement, data).then( (message) ->
            iframe.src = page_url
          ).catch( (error) ->
            if typeof(onerror) == 'function'
              onerror(error)
            else
              SharedPlayer.PlayerItemRenderer._showNonInteractive($slideElement, data)
          )
        else
          iframe.src = page_url
      catch e
        console.log(e)

    if lti
      iframeContent.getElementById('goto-lti-btn').click()
    else
      iframeContent.getElementById('goto-lti-btn').setAttribute('target','_blank')

  getFirewallToken: (url) ->
    return unless @FIREWALL_TOKEN_PARAM
    (new URLSearchParams(url.split("?")[1])).get(@FIREWALL_TOKEN_PARAM)

  appendFirewallToken: (urlWithToken, targetUrl) ->
    firewallToken = @getFirewallToken(urlWithToken)
    return targetUrl unless firewallToken

    @appendToUrl(targetUrl, @FIREWALL_TOKEN_PARAM, firewallToken)

LP.WebpagePreview = WebpagePreview
